import * as React from 'react'

import Svg, { Defs, Path, RadialGradient, Rect, Stop } from 'react-native-svg'

const EmptyLeadIcon = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={73}
    height={73}
    fill="none"
    {...props}
  >
    <Path
      fill="url(#a)"
      d="M37.977 25.816h-5.744L29.936 7.041a20.832 20.832 0 0 1 13.785 0c-2.297 8.214-3.446 11.734-5.744 18.775Z"
    />
    <Path
      fill="url(#b)"
      d="M21.894 25.816h5.744l2.297-18.775a20.831 20.831 0 0 0-13.785 0c2.297 8.214 3.446 11.734 5.744 18.775Z"
    />
    <Path
      fill="url(#c)"
      d="M34.53 19.949h-9.19L23.043 1.173a20.832 20.832 0 0 1 13.785 0L34.531 19.95Z"
    />
    <Path
      fill="url(#d)"
      d="M52.912 51.045c0 12.908-10.34 12.322-22.976 12.322-12.638 0-22.977.586-22.977-12.322S17.299 19.95 29.936 19.95c12.636 0 22.976 18.188 22.976 31.096Z"
    />
    <Path
      fill="#808B9C"
      d="M38.613 41.653c0 5.873-4.661 10.634-10.411 10.634-3.031 0-5.76-1.323-7.662-3.435-.5-.554-.942-1.163-1.319-1.816a10.761 10.761 0 0 1-1.43-5.383c0-5.874 4.661-10.635 10.411-10.635 1.923 0 3.725.533 5.27 1.462.64.384 1.236.836 1.778 1.347a10.708 10.708 0 0 1 3.363 7.826Z"
    />
    <Path
      fill="#fff"
      d="M32.478 39.122h-1.417a3.53 3.53 0 0 0-.367-.908h1.784a.86.86 0 0 0 .85-.869.86.86 0 0 0-.85-.868h-8.03a.86.86 0 0 0-.85.868c0 .48.381.869.85.869h3.28c.651 0 1.22.366 1.518.908h-4.797a.86.86 0 0 0-.85.868c0 .48.38.868.85.868h4.797a1.735 1.735 0 0 1-1.517.909h-3.28a.85.85 0 0 0-.78.524.882.882 0 0 0 .161.94l4.622 5.01a.84.84 0 0 0 1.202.037.881.881 0 0 0 .035-1.227l-3.272-3.548h1.312c1.603 0 2.953-1.126 3.333-2.645h1.416a.86.86 0 0 0 .85-.868.86.86 0 0 0-.85-.868Z"
    />
    <Path
      fill="#808B9C"
      d="M39.126 19.714H20.745c-1.269 0-2.298 1.05-2.298 2.347 0 1.296 1.029 2.347 2.298 2.347h18.381c1.269 0 2.298-1.05 2.298-2.347 0-1.296-1.029-2.347-2.298-2.347Z"
    />
    <Path
      fill="#6C7789"
      d="m67.14 48.414-24.817 18.82a3.029 3.029 0 0 1-4.295-.652L27.077 51.514c-1.012-1.392-.73-3.357.631-4.389l24.817-18.82a3.029 3.029 0 0 1 4.296.653l10.95 15.068c1.012 1.392.73 3.357-.631 4.388Z"
    />
    <Path
      fill="#fff"
      d="m29.375 52.555 1.639 2.255a.968.968 0 0 0 1.373.209l26.18-19.854c.435-.33.526-.958.202-1.403l-1.638-2.255a.968.968 0 0 0-1.374-.209l-26.18 19.854c-.435.33-.525.958-.202 1.403Z"
    />
    <Path
      fill="url(#e)"
      d="m59.774 42.082-29.937 4.147c-2.086.289-3.576 2.074-3.32 3.978l2.502 18.65c.256 1.905 2.161 3.22 4.248 2.93l29.936-4.147c2.087-.29 3.576-2.074 3.32-3.978l-2.502-18.65c-.255-1.905-2.16-3.22-4.247-2.93Z"
    />
    <Path
      fill="#fff"
      d="m37.919 54.872-6.574.91c-.486.068-.942-.334-1.017-.897l-.584-4.35c-.076-.563.257-1.075.744-1.142l6.573-.91c.486-.068.942.334 1.017.897l.584 4.35c.076.563-.257 1.075-.743 1.142Z"
    />
    <Rect
      width={7.573}
      height={1.289}
      fill="#fff"
      rx={0.645}
      transform="matrix(.99054 -.13723 .13298 .99112 54.042 46.564)"
    />
    <Rect
      width={6.31}
      height={2.149}
      fill="#fff"
      rx={1.074}
      transform="matrix(.99054 -.13723 .13298 .99112 32.507 63.215)"
    />
    <Rect
      width={6.31}
      height={2.149}
      fill="#fff"
      rx={1.074}
      transform="matrix(.99054 -.13723 .13298 .99112 40.841 62.06)"
    />
    <Rect
      width={6.31}
      height={2.149}
      fill="#fff"
      rx={1.074}
      transform="matrix(.99054 -.13723 .13298 .99112 49.175 60.906)"
    />
    <Rect
      width={6.31}
      height={2.149}
      fill="#fff"
      rx={1.074}
      transform="matrix(.99054 -.13723 .13298 .99112 57.51 59.75)"
    />
    <Rect
      width={5.048}
      height={1.289}
      fill="#fff"
      rx={0.645}
      transform="matrix(.99054 -.13723 .13298 .99112 56.829 48.347)"
    />
    <Defs>
      <RadialGradient
        id="a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-6.50968 14.0047 -6.98362 -3.24613 38.92 10.204)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#E6ECF7" />
        <Stop offset={1} stopColor="#A7B3C7" />
      </RadialGradient>
      <RadialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-6.50968 14.0047 -6.98362 -3.24613 25.134 10.204)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#E6ECF7" />
        <Stop offset={1} stopColor="#A7B3C7" />
      </RadialGradient>
      <RadialGradient
        id="c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-6.50968 14.0047 -6.98362 -3.24613 32.027 4.337)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#E6ECF7" />
        <Stop offset={1} stopColor="#A7B3C7" />
      </RadialGradient>
      <RadialGradient
        id="d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-21.69884 30.48363 -18.78846 -13.37399 36.907 29.389)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#E6ECF7" />
        <Stop offset={1} stopColor="#A7B3C7" />
      </RadialGradient>
      <RadialGradient
        id="e"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-15.30222 20.3962 -13.24658 -9.93822 51.24 48.923)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#E6ECF7" />
        <Stop offset={1} stopColor="#A7B3C7" />
      </RadialGradient>
    </Defs>
  </Svg>
)
export default EmptyLeadIcon
